import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import countries from '../../../json/country.json'
import { stripHtml } from '../../../helpers/stripHtml'
import uuid from 'react-uuid';
import { MySwal } from '../../../lib/swal';

const AddParticipantBpComp = (props) => {
    // console.log(props)

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const [required, setRequired] = useState(false);
    const dispatch = useDispatch()
    const participants = useSelector(state => state.bpParticipants)

    const [namaDepanPeserta, setNamaDepanPeserta] = useState('');
    const [namaBelakangPeserta, setNamaBelakangPeserta] = useState('');
    const [salutationPeserta, setSalutationPeserta] = useState('');
    const [jabatanPeserta, setJabatanPeserta] = useState('');
    const [kodeHpPeserta, setKodeHpPeserta] = useState('+62');
    const [hpPeserta, setHpPeserta] = useState('');
    const [emailPeserta, setEmailPeserta] = useState('');

    const handleChangeNegara = (value) => {
        setKodeHpPeserta(value)
        setHpPeserta(`(${value})`)
    }

    const handleAddParticipant = () => {
        // alert('masuk')
        // return false
        if (
            namaBelakangPeserta.length === 0 ||
            salutationPeserta.length === 0 ||
            jabatanPeserta.length === 0 ||
            emailPeserta.length === 0
        ) {
            setRequired(true)
        } else {
            if (hpPeserta.length > 8) {
                const checkIsExist = participants.some(
                    item => emailPeserta === item.emailPeserta
                );

                if (checkIsExist === true) {
                    MySwal.fire({
                        icon: 'warning',
                        title: 'Oops, Kesalahan!',
                        text: 'Email Peserta sudah terdaftar.',
                        confirmButtonColor: '#6e7d88',
                    })
                } else {
                    const obj = {
                        idPeserta: uuid(),
                        bpId: props.bpId,
                        namaDepanPeserta: namaDepanPeserta,
                        namaBelakangPeserta: namaBelakangPeserta,
                        salutationPeserta: salutationPeserta,
                        jabatanPeserta: jabatanPeserta,
                        kodeHpPeserta: kodeHpPeserta,
                        hpPeserta: kodeHpPeserta.concat(hpPeserta),
                        emailPeserta: emailPeserta,
                    }
                    // console.log(obj)
                    // return false
                    dispatch({
                        type: 'SET_BP_PARTICIPANTS',
                        payload: obj
                    });

                    const objParticipants = {
                        firstName: namaDepanPeserta,
                        lastName: namaBelakangPeserta,
                        email: emailPeserta,
                        position: jabatanPeserta,
                        mobilePhone: kodeHpPeserta.concat(hpPeserta),
                    }
                    // console.log(objParticipants)
                    dispatch({
                        type: 'SET_BP_PARTICIPANT_TO_SCHEDULE',
                        payload: objParticipants,
                        bpId: props.bpId
                    });

                    dispatch({ type: 'SET_VALIDATE', 'value': true });

                    setRequired(false)

                    props.close()
                }
            } else {
                setRequired(true)
                MySwal.fire({
                    icon: 'warning',
                    title: 'Oops, Kesalahan!',
                    text: 'Nomor Handphone minimal 9 digit.',
                })
            }
        }

    }

    // console.log(participants)

    return (
        <>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600' }} htmlFor='NamaDepan' className="form-label">Nama Depan</label>
                    <input type="text" id='NamaDepan' className="form-control form-control-solid" onChange={(e) => setNamaDepanPeserta(stripHtml(e.target.value))} value={namaDepanPeserta} />
                </div>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600', color: (namaBelakangPeserta.length === 0 && required === true) ? '#F1416C' : '' }} htmlFor='NamaBelakang' className="form-label required">Nama Belakang</label>
                    <input type="text" id='NamaBelakang' className="form-control form-control-solid" onChange={(e) => setNamaBelakangPeserta(stripHtml(e.target.value))} value={namaBelakangPeserta} style={{ borderColor: (namaBelakangPeserta.length === 0 && required === true) ? '#F1416C' : '' }} />
                </div>
                <p className='mt-2' style={{ fontSize: '12px', fontWeight: '400' }}>Apabila nama anda terdiri dari satu kata: Nama Depan : <b>Budianto</b>, Nama Belakang : <b>Budianto</b></p>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-12'>
                    <label style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600', color: (salutationPeserta.length === 0 && required === true) ? '#F1416C' : '' }} htmlFor="salutationPeserta" className="form-label required">Sapaan / Salutation</label>
                    <select className="form-select form-select-solid" aria-label="Select example" id='salutationPeserta' onChange={(e) => setSalutationPeserta(e.target.value)} value={salutationPeserta} style={{ borderColor: (salutationPeserta.length === 0 && required === true) ? '#F1416C' : '' }}>
                        <option value=''>Pilih</option>
                        <option value='Mr'>Mr</option>
                        <option value='Mrs'>Mrs</option>
                        <option value='Ms'>Ms</option>
                    </select>
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-12'>
                    <label style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600' }} htmlFor='JabatanIndividu' className="form-label required">Jabatan</label>
                    <input type="text" id='JabatanIndividu' className="form-control form-control-solid mb-3" placeholder='Jabatan' onChange={(e) => setJabatanPeserta(stripHtml(e.target.value))} value={jabatanPeserta} style={{ borderColor: (jabatanPeserta.length === 0 && required === true) ? '#F1416C' : '' }} />
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='row col-lg-12'>
                    <div className='col-lg-4 col-12'>
                        <label style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600', color: (kodeHpPeserta.length === 0 && required === true) ? '#F1416C' : '' }} htmlFor='Country' className="form-label required">Negara</label>
                        <select className="form-select form-select-solid" id='Country' onChange={(e) => handleChangeNegara(e.target.value)} value={kodeHpPeserta} style={{ borderColor: (kodeHpPeserta.length === 0 && required === true) ? '#F1416C' : '' }}>
                            <option value="+62">Indonesia ({kodeHpPeserta})</option>
                            {countries.countries.map((country, key) =>
                                <option value={country.code}>{country.name} ({country.code})</option>
                            )}
                        </select>
                    </div>
                    <div className='col-lg-8 col-12'>
                        <label style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600', color: (hpPeserta.length < 17 && required === true) ? '#F1416C' : '' }} htmlFor='Country' className="form-label required">Nomor Handphone</label>
                        <input type="text" id='Country' className="form-control form-control-solid" placeholder='81234567890' onChange={(e) => setHpPeserta(e.target.value)} value={hpPeserta} style={{ borderColor: (hpPeserta.length < 17 && required === true) ? '#F1416C' : '' }} />
                    </div>
                    <p className='mt-2' style={{ fontSize: '12px', fontWeight: '400' }}>Contoh : 8123456789 (Gunakan nomor yang terhubung dengan WhatsApp)</p>
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-12'>
                    <label style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600', color: (emailPeserta.length === 0 && required === true) ? '#F1416C' : '' }} htmlFor='Email' className="form-label required">Email</label>
                    <input type="email" id='Email' className="form-control form-control-solid" onChange={(e) => setEmailPeserta(e.target.value)} value={emailPeserta} style={{ borderColor: (emailPeserta.length === 0 && required === true) ? '#F1416C' : '' }} />
                </div>
            </div>
            <div className='d-flex justify-content-end mt-5 mb-5'>
                {
                    <button style={{ fontSize: size.width < 500 ? '15px' : '20px', fontWeight: '400', backgroundColor: '#26D07C', color: '#F2F2F2' }} type='button' className='btn btn-success' onClick={handleAddParticipant}>Tambah Peserta</button>
                }
            </div>
        </>
    )
}

export default AddParticipantBpComp
